import * as PlaybackStateActions from "actions/PlaybackStateActions";
import React from "react";
import { connect } from "react-redux";
import getPlaybackState from "selectors/chapter/getPlaybackState";
import classnames from "classnames";
import ControlButton from "./ControlButton";
import { Seek } from "./Seek";
import styles from "./seekForwardButton/SeekForwardButton.module.css";

export const SeekForwardButton = connect(
  (state, ownProps) => ({
    time: getPlaybackState(state, ownProps).time,
  }),
  undefined,
  (stateProps, { dispatch }, ownProps) => {
    return {
      ...ownProps,
      onClick: () =>
        dispatch(
          PlaybackStateActions.changePlaybackState(ownProps, {
            scrubbing: false,
            time: stateProps.time + 15000,
          }),
        ),
    };
  },
)((props) => {
  return (
    <ControlButton
      ariaLabel="seek 15 seconds forward"
      className={classnames(props.className, styles.root)}
      classNameModifiers={["icon"]}
      data-testid="seek-back-button"
      {...props}
    >
      <Seek direction="forward" />
    </ControlButton>
  );
});
